import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    getStatus(){
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/faopname/status/`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    getCategory(){
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/faopname/category/`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'asdesc', 'tgl1', 'tgl2','uraian'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/faopname${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(obj) {
        console.log('obj',obj)
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post('/faopname', obj);
                console.log('data',data)
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/faopname/detail/${obj.assetOpnamKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    saveAssetAudit(obj){
        console.log('obj',obj)
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.put(`/faopname/saveAssetAudit/${obj.assetOpnamDtlKey}`,obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }
}